import { createContext, ReactNode, useContext } from 'react';

interface IGameUser {
	balance: string;
}

const emptyGameUser: IGameUser = {
	balance: '0',
};

/**
 * @TODO: Fetch all user-related data here (`user address` and `game address` subject as params)
 */
export const GameUserProvider = ({ children, value = emptyGameUser }: { children: ReactNode; value: IGameUser }) => {
	return <GameUserContext.Provider value={value}>{children}</GameUserContext.Provider>;
};

const GameUserContext = createContext(emptyGameUser);

export const useGameUserProvider = () => {
	return useContext(GameUserContext);
};
